/* eslint-disable */

//tslint:disable

import { IModel, IModelResponse } from '@cian/http-api/shared/model';

export type TWebDeleteFavoriteModel = IModel<IWebDeleteFavoriteRequest, TWebDeleteFavoriteResponse>;

export interface IWebDeleteFavoriteRequest {
  /** Тип сделки **/
  dealType: EDealType;
  /** Ид сущности **/
  entityId: number;
  /** Тип сущности **/
  entityType: EEntityType;
  /** Принудительно удалить из папок **/
  forceRemoveFromFolders?: boolean | null;
}

export type TWebDeleteFavoriteResponse =
  | IWebDeleteFavoriteResponse400
  | IWebDeleteFavoriteResponse200
  | IWebDeleteFavoriteResponse204;

export interface IWebDeleteFavoriteResponse400 extends IModelResponse<IWebDeleteFavoriteResponseError> {
  statusCode: 400;
}

export interface IWebDeleteFavoriteResponse200 extends IModelResponse<IWebDeleteFavoriteResponse> {
  statusCode: 200;
}

export interface IWebDeleteFavoriteResponse204 extends IModelResponse<{}> {
  statusCode: 204;
}

export interface IWebDeleteFavoriteResponseError {
  errors: any[];
  message: string;
}

export interface IWebDeleteFavoriteResponse {}

export type TResponses = IWebDeleteFavoriteResponseError | IWebDeleteFavoriteResponse | {};

export enum EDealType {
  /** Аренда **/
  Rent = 'rent',
  /** Продажа **/
  Sale = 'sale',
}

export enum EEntityType {
  /** Коммерческая **/
  Commercial = 'commercial',
  /** ЖК **/
  Newbuilding = 'newbuilding',
  /** Жилая **/
  Residential = 'residential',
  /** Загородка **/
  Suburban = 'suburban',
}

export interface IMappers<TResponse400, TResponse200, TResponse204> {
  400(response: IWebDeleteFavoriteResponseError): TResponse400;
  200(response: IWebDeleteFavoriteResponse): TResponse200;
  204(): TResponse204;
}
